import * as React from 'react';
import BowtieThemeProvider from './BowtieThemeProvider';
import MuiV4ThemeProvider from './MuiV4ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const RootThemeProvider = ({
  children,
  lang,
  v4Theme,
  brand
}) => _jsx(MuiV4ThemeProvider, {
  options: {
    lang,
    theme: v4Theme
  },
  children: _jsx(BowtieThemeProvider, {
    lang: lang,
    brand: brand,
    children: children
  })
});
export default RootThemeProvider;